/**
 * Модуль хранит цвета из цветовой палитры antd,
 * сочетающейся с основными цветами элементов UI:
 * https://ant.design/docs/spec/colors
 */

// Gray
export const COLORS_GRAY_01 = '#fff';
export const COLORS_GRAY_02 = '#fafafa';
export const COLORS_GRAY_03 = '#f5f5f5';
export const COLORS_GRAY_04 = '#f0f0f0';
export const COLORS_GRAY_05 = '#d9d9d9';
export const COLORS_GRAY_06 = '#bfbfbf';
export const COLORS_GRAY_07 = '#8c8c8c';
export const COLORS_GRAY_08 = '#595959';
export const COLORS_GRAY_09 = '#434343';
export const COLORS_GRAY_10 = '#262626';
export const COLORS_GRAY_11 = '#1f1f1f';
export const COLORS_GRAY_12 = '#141414';
export const COLORS_GRAY_13 = '#000';

// Blue
export const COLORS_BLUE_01 = '#e6f4ff';
export const COLORS_BLUE_02 = '#bae0ff';
export const COLORS_BLUE_03 = '#91caff';
export const COLORS_BLUE_04 = '#69b1ff';
export const COLORS_BLUE_05 = '#4096ff';
export const COLORS_BLUE_06 = '#1677ff';
export const COLORS_BLUE_07 = '#0958d9';
export const COLORS_BLUE_08 = '#003eb3';
export const COLORS_BLUE_09 = '#002c8c';
export const COLORS_BLUE_10 = '#001d66';

// Orange
export const COLORS_ORANGE_01 = '#fff7e6';
export const COLORS_ORANGE_02 = '#ffe7ba';
export const COLORS_ORANGE_03 = '#ffd591';
export const COLORS_ORANGE_04 = '#ffc069';
export const COLORS_ORANGE_05 = '#ffa940';
export const COLORS_ORANGE_06 = '#fa8c16';
export const COLORS_ORANGE_07 = '#d46b08';
export const COLORS_ORANGE_08 = '#ad4e00';
export const COLORS_ORANGE_09 = '#873800';
export const COLORS_ORANGE_10 = '#612500';

// Green
export const COLORS_GREEN_01 = '#f6ffed';
export const COLORS_GREEN_02 = '#d9f7be';
export const COLORS_GREEN_03 = '#b7eb8f';
export const COLORS_GREEN_04 = '#95de64';
export const COLORS_GREEN_05 = '#73d13d';
export const COLORS_GREEN_06 = '#52c41a';
export const COLORS_GREEN_07 = '#389e0d';
export const COLORS_GREEN_08 = '#237804';
export const COLORS_GREEN_09 = '#135200';
export const COLORS_GREEN_10 = '#092b00';

// Red
export const COLORS_RED_01 = '#fff1f0';
export const COLORS_RED_02 = '#ffccc7';
export const COLORS_RED_03 = '#ffa39e';
export const COLORS_RED_04 = '#ff7875';
export const COLORS_RED_05 = '#ff4d4f';
export const COLORS_RED_06 = '#f5222d';
export const COLORS_RED_07 = '#cf1322';
export const COLORS_RED_08 = '#a8071a';
export const COLORS_RED_09 = '#820014';
export const COLORS_RED_10 = '#5c0011';

// Yellow
export const COLORS_YELLOW_01 = '#feffe6';
export const COLORS_YELLOW_02 = '#ffffb8';
export const COLORS_YELLOW_03 = '#fffb8f';
export const COLORS_YELLOW_04 = '#fff566';
export const COLORS_YELLOW_05 = '#ffec3d';
export const COLORS_YELLOW_06 = '#fadb14';
export const COLORS_YELLOW_07 = '#d4b106';
export const COLORS_YELLOW_08 = '#ad8b00';
export const COLORS_YELLOW_09 = '#876800';
export const COLORS_YELLOW_10 = '#614700';
